<template>
  <b-modal id="modal_portal_qrCode" :title="$t('unitDetails.portalQrTitle')" ok-only class="mx-auto" header-text-variant="dark" body-text-variant="dark">
    <div class="d-block text-center">
      <p>{{$t('unitDetails.portalQrText')}}</p>
      <qrcode-vue :value="url" :size="size" level="H"></qrcode-vue>
    </div>
  </b-modal>
</template>

<script>
import QrcodeVue from 'qrcode.vue'

export default {
  name: "PortalQrModel",
  props: {
    url: {type: String},
  },
  data() {
      return {
        size: 300,
      }
    },
    components: {
      QrcodeVue,
    },
}
</script>

<style scoped>

</style>